import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUser } from 'context/UserContext'
import { ChoiceButton } from 'components/ChoiceButton'
import { ButtonWrapper } from 'components/ButtonWrapper'
import { Heading } from 'components/Heading'

interface Props {
  nextRoute: string
}

export const ExperienceYoga: React.FC<Props> = ({ nextRoute }) => {
  const { t } = useTranslation('translation', {
    useSuspense: false,
  })

  const navigate = useNavigate()
  const { user, setUser } = useUser()
  const genderBasedBackground =
    user.gender === 'm'
      ? 'bg-goal-weight-male bg-center'
      : 'bg-goal-weight-female bg-center'

  const onButtonClick = (choiceId: number) => {
    setUser({ ...user, experienceYogaChoiceId: choiceId })
    navigate(nextRoute)
  }

  return (
    <div className={`default-container ${genderBasedBackground} flex flex-col`}>
      <div className="flex h-full flex-col justify-between self-center overflow-auto px-7 pb-10 pt-7 lg:w-5/6 xl:w-5/12">
        <Heading text={t('experience_yoga.headline')} />

        <ButtonWrapper>
          <ChoiceButton
            onClick={() => onButtonClick(1)}
            value={t('experience_yoga.option_1')}
            id="option_1"
          />
          <ChoiceButton
            onClick={() => onButtonClick(2)}
            value={t('experience_yoga.option_2')}
            id="option_2"
          />
          <ChoiceButton
            onClick={() => onButtonClick(3)}
            value={t('experience_yoga.option_3')}
            id="option_3"
          />
        </ButtonWrapper>
      </div>
    </div>
  )
}
